module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=BD - Bangladesh.0b95aa1f.svg";